<div class="wrapper">
  <div class="title">{{ groupName }}</div>
  <hr class="horizontalLine"/>

  <div class="contentContainer">

    <div class="calendarContainer">
      @if (calendars != null) {
        @for (calendar of calendars; track calendar) {
          <tun-calendar-view
            class="calendar"
            [imageHolder]="calendar"
            [playButtonShowStragegy]="ON_HOVER"
            (showDetails)="onShowDetails($event)"
            >
          </tun-calendar-view>
        }
      }

      @if (showAddButton) {
        <div class="calendar">
          <div class="addButtonContainer">
            <button
              class="addButton "
              (click)="onAdd()"
              >
              <div class="addButtonIconContainer">
                <tun-plus-icon-v5 class="icon icon-scaled-svg-button addIcon"></tun-plus-icon-v5>
              </div>
            </button>
          </div>
        </div>
      }

    </div>

    @if (lockOverlayMessage != null) {
      <tun-access-right-overlay-view
        class="overlayContainer"
        [message]="lockOverlayMessage"
        [smallMode]="true"
        >
      </tun-access-right-overlay-view>
    }

  </div>

</div>
